import React, { Component } from "react";
import AUX from "../../hoc/Aux_";
import MUIDataTable from "mui-datatables";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormHelperText from "@material-ui/core/FormHelperText";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import Button from "@material-ui/core/Button";
import BorderColorTwoToneIcon from "@material-ui/icons/BorderColorTwoTone";
import DeleteIcon from "@material-ui/icons/DeleteTwoTone";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import IconButton from "@material-ui/core/IconButton";
import { Alert, AlertTitle } from "@material-ui/lab";
import CloseIcon from "@material-ui/icons/Close";

import Dialog from "@material-ui/core/Dialog";
import DialogDetail from "../../components/Kugi/dialogdetail";

import EditCms from "./EditLayer";
import AddCms from "./AddLayer";

import Typography from "@material-ui/core/Typography";
import Breadcrumbs from "@material-ui/core/Breadcrumbs";
import { Link } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import { deleteLayer, fetchLayer } from "../../api/cms";
import { pushSelectedCategory } from "../../actions/general";
import { connect } from "react-redux";

class LayerData extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      fcid: 1,
      action: "add",
      code: "",
      layerData: [],
      loader: true,
      layerSelected: [],
      openWarning: false,
    };
  }

  componentWillMount() {
    if (localStorage.getItem("token") == null) {
      console.log(localStorage.getItem("token"));
      this.props.history.push(`/login`);
    }

    fetchLayer()
      .then((res) => {
        this.setState({ layerData: res.data, loader: false });
      })
      .catch((err) => {
        console.log(err);
        this.setState({ loader: false });
      });
  }

  handleDeleteDialog = (e) => {
    this.setState({ openWarning: true, layerSelected: e });
  };

  handleDelete = (e) => {
    console.log(e);
    deleteLayer(e)
      .then(() => {
        toast.success("Sukses menghapus data", {
          position: "bottom-left",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        this.setState({ openWarning: false })
        this.handleReload();
      })
      .catch((error) => {
        toast.error("Gagal menghapus data", {
          position: "bottom-left",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        console.log(error);
        this.setState({ openWarning: false })
      });
  };

  handleChange = (e) => {
    this.setState({
      selected: e.target.value,
      categorySelected: e.target.value,
    });
    this.props.pushSelectedCategory(e.target.value);

    // fetchCms(e.target.value)
    //   .then((response) => {
    //     this.setState({ layerData: response.data });
    //   })
    //   .catch((error) => {
    //     console.log(error);
    //   });
  };

  handleClose = () => {
    this.setState({ open: false });
  };

  renderMenu = (e) => {
    return (
      <MenuItem value={e.featureCatalogId.replace("@en", "")}>
        {e.name.replace("@en", "")}
      </MenuItem>
    );
  };

  handleUpdate = (e) => {
    console.log(e);
    this.setState({ open: true, action: "edit", layerSelected: e });
  };

  handleReload = (e) => {
    fetchLayer()
      .then((res) => {
        this.setState({ layerData: res.data });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  renderAddEdit = () => {
    if (this.state.action == "edit") {
      return (
        <EditCms
          handleOpen={this.handleClose}
          layerData={this.state.layerData}
          dataSelected={this.state.layerSelected}
          handleReload={this.handleReload}
        />
      );
    } else {
      return (
        <AddCms
          handleOpen={this.handleClose}
          handleReload={this.handleReload}
        />
      );
    }
  };

  render() {
    const options = {
      filter: false,
      selectableRows: false,
      responsive: "scroll",
      textLabels: {
        body: {
          noMatch: this.state.loader
            ? "Searching..."
            : "Sorry, no matching records found",
        },
      },
    };

    const columns = [
      {
        name: "gid",
        label: "Update",
        options: {
          filter: true,
          sort: false,
          customBodyRender: (value, tableMeta, updateValue) => (
            <BorderColorTwoToneIcon
              color="primary"
              onClick={(event) => this.handleUpdate(value)}
              style={{ cursor: "pointer" }}
            />
          ),
        },
      },
      { name: "nama", label: "Nama" },
      {
        name: "host",
        label: "Host",
        options: {
          setCellProps: () => ({
            style: { maxWidth: "200px", wordWrap: "break-word" },
          }),
        },
      },
      { name: "layer", label: "Layer" },
      { name: "sublayer", label: "Sublayer" },
      { name: "kategori", label: "Kategori" },
      {
        name: "gid",
        label: "Delete",
        options: {
          filter: true,
          sort: false,
          customBodyRender: (value, tableMeta, updateValue) => (
            <DeleteIcon
              color="primary"
              onClick={(event) => this.handleDeleteDialog(tableMeta.rowData)}
              style={{ cursor: "pointer" }}
            />
          ),
        },
      },
    ];

    return (
      <AUX>
        <Dialog
          open={this.state.open}
          fullScreen
          maxWidth={""}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle
            disableTypography
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <span />
            <IconButton onClick={this.handleClose}>
              <CloseIcon />
            </IconButton>
          </DialogTitle>
          <DialogContent>{this.renderAddEdit()}</DialogContent>
        </Dialog>

        <Dialog
          open={this.state.openWarning}
          onClose={() => this.setState({ openWarning: false })}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">Delete Data WMS</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              Apakah anda yakin ingin menghapus data dengan nama{" "}
              <span style={{ fontWeight: "bold" }}>
                {this.state.layerSelected[1]}
              </span>
              ?
            </DialogContentText>
            <DialogActions>
              <Button
                variant="contained"
                style={{
                  backgroundColor: "#497ac2",
                  color: "#FFF",
                  outline: "none",
                }}
                onClick={() => this.handleDelete(this.state.layerSelected[0])}
              >
                Ya
              </Button>
              <Button
                variant="contained"
                style={{
                  outline: "none",
                }}
                onClick={() => this.setState({ openWarning: false })}
              >
                Tidak
              </Button>
            </DialogActions>
          </DialogContent>
        </Dialog>

        <section className="sections" style={{ paddingTop: "5%" }}>
          <center>
            <h3>Data WMS</h3>
          </center>
          <div className="row justify-content-center" />
          <div className="container">
            <Button
              variant="contained"
              color="primary"
              onClick={() => {
                this.setState({ open: true, action: "add" });
              }}
              style={{ marginBottom: 20 }}
            >
              Tambah Layer
            </Button>
            <MUIDataTable
              data={this.state.layerData}
              columns={columns}
              options={options}
            />
            <div className="container">
              <div className="row justify-content-center" id="counter" />
            </div>
          </div>
          <ToastContainer
            position="bottom-left"
            autoClose={5000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
          />
        </section>
      </AUX>
    );
  }
}

const mapStatetoProps = (state) => {
  return {
    categorySelected: state.categorySelected,
  };
};

export default connect(
  mapStatetoProps,
  { pushSelectedCategory }
)(LayerData);
